export default __webpack_public_path__ + "static/media/landType.90bdf3ca.png";